// @flow

import {closestIndex} from './closestIndex';
import {SCROLL_DIRECTION} from '../constants';

type Params = {|
    scrollOffsetTop: number,
    rowsOffset: Array<number>,
    direction: $Values<typeof SCROLL_DIRECTION>,
    overscanRows?: number,
|};

export const getRowStartIndex = ({scrollOffsetTop, rowsOffset, direction, overscanRows}: Params): number => {
    const validatedOverscanRows = direction === SCROLL_DIRECTION.up ? overscanRows : 0;
    const startIndex = closestIndex(scrollOffsetTop, rowsOffset) - Number(validatedOverscanRows);
    return startIndex >= 0 ? startIndex : 0;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../constants");
